<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm08_part01"><a id="page_1"></a><strong><span class="smallcaps">ACT ONE</span><br/><br/>See with<br/>Both Eyes</strong><a id="page_2"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm08_part01.vue?12e2b3dc